import './public-path';
import { picoapp } from 'picoapp';
import AppComponents from './AppComponents';
import AppState from './AppState';
import common from './features/common';
import icons from './features/icons';
// import '@zachleat/table-saw';
import webfonts from './features/webfonts';
const app = picoapp(AppComponents, AppState);
import '../sass/theme.scss';
console.log("picoapp ",app)
app.mount(['data-component']);


console.log("picoqpp1",Object.keys(app)); // Lists top-level properties of the `app` object.
console.log("picoqpp2",app.getState);
window.app = app;
common.init(app);
icons.init();
webfonts.init();

// Remount components on section re-renders
document.addEventListener('shopify:section:load', () => {
  app.mount(['data-component']);
});
